import type { Translatable} from "@@/shared/translations/translation";
import { translation } from "@@/shared/translations/translation";
import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const pageBlockTitleVerticalPlacements = ["top", "middle", "bottom"] as const;
type PageBlockTitleVerticalPlacement =
    (typeof pageBlockTitleVerticalPlacements)[number];
const pageBlockTitleVerticalPlacement =
    toObjectMap<PageBlockTitleVerticalPlacement>([
        ...pageBlockTitleVerticalPlacements,
    ]);

const pageBlockTitleVerticalPlacementNames: Record<
    PageBlockTitleVerticalPlacement,
    Translatable
> = {
    top: translation({
        sv: "Längst upp",
        en: "Top",
    }),
    middle: translation({
        sv: "Mitten",
        en: "Middle",
    }),
    bottom: translation({
        sv: "Längst ner",
        en: "Bottom",
    }),
};

const pageBlockTitleVerticalPlacementZodSchema = z.enum(
    pageBlockTitleVerticalPlacements,
);

export {
    pageBlockTitleVerticalPlacement,
    pageBlockTitleVerticalPlacementNames,
    pageBlockTitleVerticalPlacements,
    pageBlockTitleVerticalPlacementZodSchema,
};
export type { PageBlockTitleVerticalPlacement };
